module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "myMap",
    staticStyle: {
      "height": "100vh"
    },
    attrs: {
      "center": _vm.center,
      "options": {
        streetViewControl: false
      },
      "zoom": 14
    }
  }, [_c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": m.position,
        "icon": m.icon
      },
      on: {
        "click": function($event) {
          return _vm.toggleInfoWindow(m, i)
        }
      }
    })
  })], 2), _vm._v(" "), _c('notifications', {
    attrs: {
      "group": "foo",
      "position": "bottom left"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a467e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mapa.vue
// module id = 340
// module chunks = 1